import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { FiAlertTriangle, FiPlusCircle, FiSave, FiSlash, FiTrash, FiTrash2 } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { CardCobroVenta } from '../../../shared/CardCobroVenta';
import { InputValidators } from '../../../../utils/InputValidators';
import Swal from 'sweetalert2';
import { closeSales } from '../../../store/Thunk';

export const M_NewMembership = ({ onClose, closeOnEscape = true, closeOnBackdrop = true }) => {

    // ============ [ GESTION DE MODAL ] ============ //
    const [isVisible, setIsVisible] = useState(false);
    const dialogRef = useRef(null);

    useEffect(() => {
        setTimeout(() => setIsVisible(true), 10);
    }, []);

    // Cerrar con Escape si está permitido
    useEffect(() => {
        if (!closeOnEscape) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") handleClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [closeOnEscape]);

    // Cerrar con clic fuera si está permitido
    const handleBackdropClick = (e) => {
        if (!closeOnBackdrop) return;
        if (dialogRef.current && !dialogRef.current.contains(e.target)) {
            handleClose();
        }
    };

    // Animación al cerrar
    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 250); // espera la animación
    };

    //========================================================================================================//


    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        didOpen: (toast) => {
            // toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });


    const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm();
    const { catMemberships, idCustomer, memberships } = useSelector(state => state.customerDetail);
    const { tipos_pagos } = useSelector(state => state.catalogos);
    const dispatch = useDispatch();
    const { id_emp } = useSelector(state => state.usuario);

    const idUser = id_emp;

    // === 
    const [ProductosCompra, setProductosCompra] = useState([]);
    const [datosCobro, setDatosCobro] = useState({
        pagos: [],
        productos: [],
        iva: 0,
        total: 0,
        totalPagado: 0,
        subtotal: 0,
        cambio: 0,
        faltante: 0,
        typeSale: 1
    });

    const handleUpdateCobro = (data) => {
        if (data.productos) {
            setProductosCompra(data.productos);
        }
        setDatosCobro(prev => ({ ...prev, ...data }));
        // onUpdate?.(data); // <- notifica al padre
    };

    const clearForm = () => {
        reset();
        setProductosCompra([]);
    }
    // === 


    const addArticulo = (data) => {

        let producto = catMemberships.filter(item => item.sku == data.categoryID);
        let sol = {
            "DI": Date.now(),
            "ID": producto[0].id,
            "NOMBRE": producto[0].name_product,
            "SKU": producto[0].sku,
            "DESCRIPCION": producto[0].product,
            "COSTO_PUBLICO": producto[0].sale_price,
            "EXISTENCIA": producto[0].currentstock,
            "DURACION": producto[0].duration_product,
            "FOLIO": watch('id'),
            "CANTIDAD": 1,
            "ACUMULADO": 1 * Number(producto[0].sale_price),
        }
        setProductosCompra([...ProductosCompra, sol]);
    }

    const save = (data) => {
        const { pagos, productos, total, totalPagado, subtotal, faltante, iva, cambio } = datosCobro;

        if (productos.length === 0) {
            Toast.fire({ icon: 'error', title: 'Debe agregar membresias, para la venta.' });
            return;
        }

        if (faltante > 0) {
            Toast.fire({ icon: 'error', title: 'Debe realizar el cobro correspondiente para la venta.' });
            return;
        }

        let flagSpecial = 0; let costoHDL = 0; let tecnico = 0; let idFacturacion = 0; let flagFacturacion = 0;

        const payload = {
            idCliente: idCustomer,
            idFacturacion: idFacturacion,
            flagFacturacion: flagFacturacion,
            flagSpecial: flagSpecial,
            capturo: idUser,
            total: total,
            iva: iva,
            subtotal: subtotal,
            pagado: totalPagado,
            cambio: cambio,
            detailPagos: pagos,
            productos: productos,
            costohdl: costoHDL,
            tecnico: tecnico,
            idcapturo: idUser
        };

        Swal.fire({
            title: 'Atención',
            text: "Está por registrar una Nueva membresia, ¿Desea de continuar con esta acción?",
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                // dispatch(activateProduct(id));
                // console.log(data);
                dispatch(closeSales(payload));
                onClose(); // cerrar modal al guardar
                reset();
            }
        })
    };

    return (
        <div className={`modal d-block custom-backdrop ${isVisible ? "show" : ""}`} onClick={handleBackdropClick}>
            <div ref={dialogRef} className={`modal-dialog modal-lg custom-modal-animate ${isVisible ? "show" : ""}`}>
                <div className="modal-content" style={{ backgroundColor: "#ffffff" }}>
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">Nueva Membresia</h5>
                        <button type="button" className="btn-close" onClick={() => { reset(); onClose(); }}></button>
                    </div>
                    {/* <form onSubmit={handleSubmit(save)}> */}
                    <div className="modal-body container">

                        <form className='row' onSubmit={handleSubmit(addArticulo)} >
                            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mb-3">
                                <label className="form-label"><span className="text-danger fw-bold">*</span> Membresia:</label>
                                <select className={`form-select ${errors.categoryID ? 'is-invalid' : ''}`}  {...register("categoryID", { required: 'Categoria, requerido' })}>
                                    <option value="" >Seleccione membresia</option>
                                    {
                                        catMemberships.map((item, index) => (
                                            <option key={index} value={item.sku} className='text-uppercase' >{item.product}</option>
                                        ))
                                    }
                                </select>
                                {
                                    errors.categoryID &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.categoryID.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-3">
                                <label className="form-label"><span className="text-danger fw-bold">*</span>ID | FOLIO:</label>
                                <div className='d-flex'>
                                    <input type="text" className={`form-control ${errors.id ? 'is-invalid' : ''}`} aria-describedby="emailHelp" autoComplete='off' {...register("id", { required: ' ID del plastico' })} />
                                    {
                                        errors.id &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="18" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.id.message}</small></span>
                                        </div>
                                    }
                                    <button type="submit" className="btn btn-outline-dark ms-2"   ><FiPlusCircle size='20' /></button>
                                </div>
                            </div>



                        </form >

                        <div className='row'>
                            <CardCobroVenta listProducts={ProductosCompra} listPaymentMethods={tipos_pagos} onUpdate={handleUpdateCobro} precioIncluyeIVA={true} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={() => { reset(); onClose(); }}>
                            <FiSlash size={16} /> Cancelar
                        </button>
                        <button type="submit" className="btn btn-outline-primary" onClick={save}>
                            <FiSave size={16} /> Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
